import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import store from "./store";
// Vuex: for services, shared components, etc
import store from './store/index';
import vuetify from './plugins/vuetify';
import DaySpanVuetify from './plugindl';

import axios from 'axios';
import VueAxios from 'vue-axios';
// import {store} from './store' // importamos el modulo de store es prueba
 
Vue.use(VueAxios, axios)
Vue.use( DaySpanVuetify,{
  someOption: true
})
Vue.config.productionTip = false;

new Vue({
   router, store, vuetify, render: h => h(App)
}).$mount("#app");
